import type { ComponentType } from "react";

import classNames from "classnames";

import type { DropdownTab } from "@similarweb/ui-components";
import { Tab, TabList, TabPanel, Tabs } from "@similarweb/ui-components";

import { StyledTabsListContainer } from "app/pages/sales-intelligence/common-components/dropdown/DropdownTabs/styles";
import type { DropdownTabPanelProps } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/TabbedDropdown/DropdownTabPanel/DropdownTabPanel";

import withDropdownSmartTabs from "../../../sub-modules/advanced-search/hoc/withDropdownSmartTabs";

export type DropdownTabsProps<T> = {
    selectedTabIndex: number;
    tabs: readonly DropdownTab<T>[];
    onItemClick(item: T): void;
    onTabSelect(index: number): void;
    isSingleSelect?: boolean;
    height?: number;
    tooltipForDisabledItem?: string;
    panelComponent: ComponentType<DropdownTabPanelProps<T>>;
};

const DropdownTabs = <T,>(props: DropdownTabsProps<T>) => {
    const {
        selectedTabIndex,
        tabs,
        onTabSelect,
        onItemClick,
        isSingleSelect,
        height,
        tooltipForDisabledItem,
        panelComponent: DropdownPanel,
    } = props;

    return (
        <Tabs
            onSelect={onTabSelect}
            selectedIndex={selectedTabIndex}
            className="tabbed-dd-tabs"
        >
            <StyledTabsListContainer>
                <TabList>
                    {tabs.map((tab) => (
                        <Tab
                            key={`tab-item-${tab.id}`}
                            disabled={tab.isDisabled}
                            data-automation={`tab-item-${tab.id}`}
                        >
                            {tab.name}
                        </Tab>
                    ))}
                </TabList>
            </StyledTabsListContainer>
            {tabs.map((tab, i) => (
                <TabPanel
                    key={`tab-panel-item-${tab.id}`}
                    className={classNames({ ["selected-tab"]: selectedTabIndex === i })}
                >
                    <DropdownPanel
                        tab={tab}
                        onItemClick={onItemClick}
                        isSingleSelect={isSingleSelect}
                        height={height}
                        tooltipForDisabledItem={tooltipForDisabledItem}
                    />
                </TabPanel>
            ))}
        </Tabs>
    );
};

export const DropdownSmartTabs = withDropdownSmartTabs(DropdownTabs);
